<!-- 包名配置 -->
<template>
  <div>
    <div class="form_box">
      <el-form :inline="true" :model="form">
        <el-form-item label="">
          <el-input v-model="form.package" placeholder="包名模糊搜索"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="
              pagination.currentPage = 1;
              getList();
            ">搜 索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- table -->
    <div>
      <el-button type="primary" class="btn" @click="
          currentData = {};
          packageDia = true;
        ">添 加</el-button>
      <el-button type="danger" @click="mulDel" class="btn">批量删除</el-button>
      <el-table :data="tableData" border style="width: 100%" :header-cell-style="{
          background: '#f8fbff',
          color: '#606266',
        }" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="包名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type_id" label="所属类型">
          <template slot-scope="scope">
            <div>
              {{ typeList[scope.row.type_id] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="attr" label="所属属性" width="250" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.attr == 0
                  ? "无属性"
                  : scope.row.attr
                      .split(",")
                      .map((item) => {
                        return attrList[item];
                      })
                      .join("/")
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="is_common" label="是否通用">
          <template slot-scope="scope">
            <div>
              {{ scope.row.is_common == 0 ? "不通用" : "通用" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operator" label="操作者"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="
                currentData = scope.row;
                packageDia = true;
              " type="text" size="small">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" background layout="total,prev, pager, next" :total="pagination.total" v-show="pagination.total != 0" :current-page="pagination.currentPage" @current-change="
          (val) => {
            pagination.currentPage = val;
            getList();
          }
        ">
      </el-pagination>
    </div>
    <PackageNameOper :visible.sync="packageDia" :current="currentData" @refresh="getList"></PackageNameOper>
  </div>
</template>
<script>
import PackageNameOper from "@/components/operation/SettingManage/components/packageNameOper";
import { getList, getType, getAttr, del } from "./api/packageName";
export default {
  name: "apkSet",
  components: { PackageNameOper },
  data() {
    return {
      form: {
        package: "",
      },
      typeList: {},
      attrList: {},
      tableData: [],
      pagination: {
        total: 0,
        currentPage: 1,
      },
      selected: [],
      packageDia: false,
      currentData: {},
    };
  },
  methods: {
    mulDel() {
      if (this.selected.length == 0) {
        this.$message.error("尚未选择包");
        return;
      }
      this.$confirm("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          del({
            ids: this.selected
              .map((item) => {
                return item.id;
              })
              .join(","),
          }).then((data) => {
            if (data.data.code == 100000) {
              this.$message.success(data.data.msg);
              this.selected = [];
              this.pagination.currentPage = 1;
              this.getList();
            } else {
              this.$message.error(data.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    init() {
      this.getType();
      this.getAttr();
      this.getList();
    },
    getAttr() {
      getAttr().then((data) => {
        this.attrList = data.data.data;
      });
    },
    getType() {
      getType().then((data) => {
        this.typeList = data.data.data;
      });
    },
    getList(page) {
      if (page) {
        this.pagination.currentPage = page;
      }
      getList({
        page: page ? page : this.pagination.currentPage,
        size: 10,
        name: this.form.package,
      }).then((data) => {
        this.tableData = data.data.data.row;
        this.pagination.total = parseInt(data.data.data.totalNum);
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.btn {
  margin-bottom: 10px;
}
.pagination {
  margin-top: 15px;
}
</style>
